import { useAuthContext } from '../providers/auth-provider';
import { useInactivityLogout } from './useInactivityLogout';

export function InactivityLogoutManager() {
  const { isAuthenticated, isInitialized, user, logout } = useAuthContext();

  useInactivityLogout({
    isEnabled: isInitialized && isAuthenticated,
    userId: user?.id ?? null,
    sessionKey: user?.sessionKey ?? null,
    inactivityLimitMs: user?.inactivityLimitMs ?? null,
    logout,
  });

  return null;
}
